import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
export function Dropzone({ onSetFile, setIsDragging, isDragging, children }) {
    function handleDragEnter(e) {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    }
    function handleDragLeave(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!e.currentTarget.contains(e.relatedTarget)) {
            setIsDragging(false);
        }
    }
    function handleDragOver(e) {
        e.preventDefault();
        e.stopPropagation();
    }
    function handleDrop(e) {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            const file = e.dataTransfer.files[0];
            onSetFile(file);
        }
    }
    return (_jsx("div", { onDragEnter: handleDragEnter, onDragLeave: handleDragLeave, onDragOver: handleDragOver, onDrop: handleDrop, className: clsx('flex h-13 w-full flex-col items-center justify-center rounded-large border-radius border-small border-dashed p-4', { 'border-primary-400 bg-primary-100': isDragging, 'border-neutral-500': !isDragging }), children: children }));
}
